"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var traverse_1 = require("./traverse");
var visitor = function (node) {
    if (traverse_1.isMemberExpression(node) && traverse_1.isIdentifier(node.property)) {
        var inputId = visitMemberExpression(node.object).join('.');
        var featureIdentifier = {
            type: 'Identifier',
            name: node.property.name,
        };
        var inputIdentifier = {
            type: 'Literal',
            value: inputId,
            raw: "\"" + inputId + "\"",
        };
        var member = {
            computed: true,
            type: 'MemberExpression',
            object: featureIdentifier,
            property: inputIdentifier,
        };
        return member;
    }
    if (isLeftRightExpression(node)) {
        if (isImpossibleMemberExpression(node.left)) {
            return visitor(node.right);
        }
        if (isImpossibleMemberExpression(node.right)) {
            return visitor(node.left);
        }
    }
    return traverse_1.traverse(node, visitor);
};
var isLeftRightExpression = function (node) {
    return traverse_1.isBinaryExpression(node) || traverse_1.isLogicalExpression(node);
};
var isImpossibleMemberExpression = function (node) {
    return traverse_1.isMemberExpression(node) &&
        traverse_1.isIdentifier(node.object) &&
        traverse_1.isIdentifier(node.property);
};
var visitMemberExpression = function (node) {
    if (traverse_1.isMemberExpression(node)) {
        if (traverse_1.isMemberExpression(node.object) && traverse_1.isIdentifier(node.property)) {
            return visitMemberExpression(node.object).concat([node.property.name]);
        }
        if (traverse_1.isIdentifier(node.object) && traverse_1.isIdentifier(node.property)) {
            return [node.object.name, node.property.name];
        }
    }
    if (traverse_1.isIdentifier(node)) {
        return [node.name];
    }
    return [];
};
exports.createExpressionTransformer = function (config) { return function (map) {
    return Object.keys(map).reduce(function (acc, path) {
        var _a;
        return __assign({}, acc, (_a = {}, _a[path] = traverse_1.traverse(map[path], visitor), _a));
    }, map);
}; };
//# sourceMappingURL=transform.js.map